export function calculateClientAge(
  intakeSurveyAge: number | null | undefined,
  policyYear: number,
): number | null {
  if (intakeSurveyAge == null) return null;
  // intakeSurveyAge is the client's age at projection start (policy year 1)
  // Each subsequent policy year adds 1 year
  return intakeSurveyAge + (policyYear - 1);
}

// Client age in a given policy year, derived from the client's birth year and
// the policy-year clock — the same absolute basis the care-timeline UI uses
// (`clientPhasePredictedStartYears[phase] − clientBirthYear`), so projection
// ages agree with the care panel by construction. The calendar year of policy
// year N is `policyPremiumStartYear + (N - 1)`, so the client's age that year is
// `calendarYear − clientBirthYear`.
//
// This intentionally does NOT use `intakeSurvey.clientAge` + an anchor year:
// `clientAge` is measured as-of-today (`calculateAge` reads `new Date()`) while
// the only anchor available at the time (`getCareCostAnchorYear`) was the
// `clientAddedDateTime` year, which can lag today by years for an existing
// client. Mixing those two anchors double-counted the years since the client
// was added, inflating every projected age (e.g. a client added 3 years ago
// showed care starting at 87 instead of 84). Anchoring on birth year removes
// that drift and works for in-force policies too (calendarYear is already
// absolute).
export function clientAgeForPolicyYear(
  clientBirthYear: number | null | undefined,
  policyYear: number,
  policyPremiumStartYear: number,
): number | null {
  if (clientBirthYear == null) return null;
  const calendarYear = policyPremiumStartYear + (policyYear - 1);
  return calendarYear - clientBirthYear;
}
